export default "__VITE_ASSET__DAj_o21n__"